import React, { useState } from 'react';
import { DataProviderInstance } from '../../../api/DataProvider';
import styles from './StepsChecklist.module.css';

const formatCheckTime = (value) => {
  const date = value ? new Date(String(value).replace(' ', 'T')) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};

const nowAsMysql = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:00`;
};

/**
 * Lista das etapas do status atual para marcar e desmarcar (drawer da agenda e
 * Início). A marcação aparece na hora e volta atrás se a gravação falhar.
 * progress vem de stepProgressFor; onChecksChange recebe as marcações novas.
 */
function StepsChecklist({ appointment, progress, onChecksChange }) {
  const { CheckAppointmentStep } = DataProviderInstance();
  const [error, setError] = useState(null);

  const toggle = (step) => {
    const previous = appointment.stepChecks || [];
    const checked = !progress.checks[step.Id];
    const optimistic = checked
      ? [...previous, { stepId: step.Id, checkedAt: nowAsMysql(), checkedBy: null }]
      : previous.filter((check) => check.stepId !== step.Id);
    setError(null);
    onChecksChange(optimistic);

    CheckAppointmentStep(appointment.id, step.Id, checked, (response) => {
      if (response?.status !== 'SUCCESS') {
        onChecksChange(previous);
        setError(response?.error || 'Não foi possível marcar a etapa. Tente de novo.');
        return;
      }
      onChecksChange(Array.isArray(response.data) ? response.data : optimistic);
    });
  };

  return (
    <>
      {progress.steps.map((step) => {
        const check = progress.checks[step.Id];
        const detail = check ? [check.checkedBy, formatCheckTime(check.checkedAt)].filter(Boolean).join(' · ') : '';
        return (
          <button
            key={step.Id}
            type="button"
            role="menuitemcheckbox"
            aria-checked={!!check}
            className={`${styles.item} ${check ? styles.itemDone : ''}`}
            onClick={() => toggle(step)}
          >
            <span className={`${styles.box} ${check ? styles.boxChecked : ''}`} aria-hidden="true">
              {check && (
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              )}
            </span>
            <span className={styles.text}>
              <span className={styles.name}>{step.Name}</span>
              {detail
                ? <span className={styles.detail}>{detail}</span>
                : !step.IsRequired && <span className={styles.detail}>Opcional</span>}
            </span>
          </button>
        );
      })}
      {error && <div className={styles.error}>{error}</div>}
    </>
  );
}

export default StepsChecklist;
